<div
  class="panel rs-box-shadow"
  [class.rs-bg-disabled]="provider === 'COMPANY'"
>
  <div *ngIf="provider === 'COMPANY'" class="row">
    <div class="columns small-9 small-push-3">
      <div class="rs-tags">
        <ul class="rs-tags-list">
          <li class="rs-tags-item">
            <div class="rs-tags-el" aria-selected="false">
              {{ "modem-choice.ont-main-device" | translate }}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="rs-flex-row">
    <div class="rs-flex-column rs-flex-shrink">
      <div class="rs-switch">
        <input
          type="checkbox"
          id="mprd-modem-choice-ont-{{ id }}"
          role="switch"
          [checked]="active"
          [disabled]="!activable"
          (change)="onActivation()"
        />
        <label
          for="mprd-modem-choice-ont-{{ id }}"
          [attr.aria-labelledby]="'mprd-modem-choice-ont-provider-' + id"
        >
          <span
            [class.rs-switch-active]="active"
            [class.rs-switch-inactive]="!active"
            aria-hidden="true"
          >
            {{ "modem-choice.ont-" + (active ? "on" : "off") | translate }}
          </span>
        </label>
      </div>
    </div>
    <div class="rs-flex-column">
      <h3
        id="mprd-modem-choice-ont-provider-{{ id }}"
        class="rs-tit5 rs-txt-c1"
      >
        {{ "modem-choice.ont-" + provider | translate }}
      </h3>
      <p class="rs-txt-s3 rs-txt-details">
        {{ serialNumber }}
      </p>
      <p class="rs-txt-s3">
        {{ "modem-choice.ont-" + accessType | translate }}
      </p>
    </div>
    <div *ngIf="provider === 'CUSTOMER'" class="rs-flex-column rs-flex-shrink">
      <div
        class="rs-action-menu"
        data-action-menu
        data-rslib-webcomponent-load="rslib.apps.actionmenu"
      >
        <button
          id="mprd-modem-choice-ont-menu-btn-{{ id }}"
          class="rs-action-menu-trigger rs-action-menu-trigger-big"
          type="button"
          [attr.data-dropdown]="'mprd-modem-choice-ont-menu-' + id"
          [attr.aria-controls]="'mprd-modem-choice-ont-menu-' + id"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i
            class="icon-Points icon-lh"
            [attr.aria-label]="'modem-choice.ont-options' | translate"
          ></i>
        </button>
        <div
          id="mprd-modem-choice-ont-menu-{{ id }}"
          class="rs-action-menu-content"
          [attr.aria-labelledby]="'mprd-modem-choice-ont-menu-btn-' + id"
          data-dropdown-content
          aria-hidden="true"
        >
          <ul class="rs-action-menu-list">
            <li class="rs-action-menu-item">
              <a
                role="button"
                tabindex="0"
                class="rs-action-menu-item-link"
                (click)="onDelete()"
              >
                <span class="rs-action-menu-item-label">
                  {{ "modem-choice.ont-delete" | translate }}
                </span>
                <span class="rs-action-menu-item-icon">
                  <i class="icon-Trash icon-lh" aria-hidden="true"></i>
                </span>
              </a>
            </li>
            <li class="rs-action-menu-item">
              <a
                role="button"
                tabindex="0"
                class="rs-action-menu-item-link"
                (click)="onEdit()"
              >
                <span class="rs-action-menu-item-label">
                  {{ "modem-choice.ont-edit" | translate }}
                </span>
                <span class="rs-action-menu-item-icon">
                  <i class="icon-Edit icon-lh" aria-hidden="true"></i>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
